import("../../../assets/js/splide.js")
	.then(({ Splide }) => {
		const sliders = document.querySelectorAll(".testimonial-slider .splide")

		for (let i = 0; i < sliders.length; i++) {
			const splideEl = sliders[i]
			const mediaPanel = document.getElementById(splideEl.id.replace("Splide", "MediaPanel"))

			const panels = [...mediaPanel.querySelectorAll("[data-media-default], [data-media-slide]")]

			const updateMedia = (index, animate = true) => {
				if (!mediaPanel) return
				const defaultMedia = mediaPanel.querySelector("[data-media-default]")
				const incoming = mediaPanel.querySelector(`[data-media-slide="${index}"]`) || defaultMedia
				const outgoing = panels.find((el) => !el.classList.contains("hidden"))

				if (incoming === outgoing) return

				const hideAll = () => {
					panels.forEach((el) => {
						el.style.opacity = ""
						el.classList.add("hidden")
					})
				}

				if (!animate || !outgoing) {
					hideAll()
					incoming.classList.remove("hidden")
					return
				}

				// Fade out the current panel, then fade in the incoming one.
				// Using inline opacity so there's no class-specificity conflict.
				outgoing.style.opacity = "0"
				outgoing.addEventListener(
					"transitionend",
					() => {
						hideAll()
						// Show incoming at opacity 0, then let two rAF ticks pass so the
						// browser renders a frame at opacity:0 before we remove it.
						// This is required for the CSS transition to fire on a newly
						// display:block element.
						incoming.style.opacity = "0"
						incoming.classList.remove("hidden")
						requestAnimationFrame(() => {
							requestAnimationFrame(() => {
								incoming.style.opacity = ""
							})
						})
					},
					{ once: true }
				)
			}

			const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches

			const splide = new Splide(splideEl, {
				type: "slide",
				arrows: true,
				pagination: true,
				perPage: 1,
				gap: "2rem",
				speed: prefersReducedMotion ? 0 : 400,
				i18n: {
					slide: "Testimonial",
				},
			})

			splide.on("mounted", () => {
				updateMedia(splide.index, false)
			})

			splide.on("moved", (newIndex) => {
				updateMedia(newIndex)
			})

			splide.mount()

			// Remove non-standard aria-roledescription from region (role="region" is sufficient)
			splideEl.removeAttribute("aria-roledescription")
		}
	})
	.catch((err) => {
		console.error(err)
	})